export const isClient = () => {
  return (
    typeof window !== 'undefined' && typeof window.document !== 'undefined'
  );
};
